module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Dr. Sofia Costa is an author, artist and reiki master with a doctorate in physical therapy. In 2020, she self-published her first book, "), _c('em', [_vm._v("The End of Back Pain: The Secret to Gaining Relief and Staying Active")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Dr. Sofia was born in Puerto Rico to a family of artists, healers, shamans and medicine men and women, allowing her to gain access to ancient wisdom and spiritual practices that amplify Heart-Earth connection. She integrates the art of alchemical medicine through movement, breathwork, sound meditation, energy healing, and handcrafted creations.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Dr. Sofia’s passion is guiding people on a heart-centred journey to alchemize fears, integrate a new way of being, and embody the power of who they are so they can strengthen their connection to Self, Earth, Lineage and Love.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To live wholeheartedly is Dr. Sofia’s intention.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0